<div class="cart-auth-modal" [class.cart-auth-modal--open]="isOpen" *ngIf="isOpen">
  <button
    type="button"
    class="cart-auth-modal__overlay"
    aria-label="Cerrar"
    (click)="close()"
  ></button>

  <div
    class="cart-auth-modal__dialog"
    role="dialog"
    aria-modal="true"
    aria-labelledby="cart-auth-modal-title"
  >
    <button
      type="button"
      class="cart-auth-modal__close"
      aria-label="Cerrar"
      (click)="close()"
    >
      <span aria-hidden="true">&times;</span>
    </button>

    <h2 id="cart-auth-modal-title" class="cart-auth-modal__title">Mi Cuenta MEGA</h2>
    <p class="cart-auth-modal__subtitle">En Mi Cuenta tienes el control.</p>

    <form class="cart-auth-modal__form" [formGroup]="loginForm" (ngSubmit)="onLoginSubmit()">
      <div class="form-group">
        <label for="cart-auth-email">Correo Electrónico</label>
        <input
          id="cart-auth-email"
          type="text"
          class="form-control"
          formControlName="username"
          placeholder="Correo electrónico"
          autocomplete="username"
          [attr.aria-invalid]="loginForm.controls.username.invalid && loginForm.controls.username.touched"
        />
      </div>

      <div class="form-group">
        <label for="cart-auth-password">Contraseña</label>
        <div class="cart-auth-modal__password-wrap">
          <input
            id="cart-auth-password"
            [type]="hidePassword ? 'password' : 'text'"
            class="form-control"
            formControlName="password"
            placeholder="Ingresa tu contraseña"
            maxlength="16"
            autocomplete="current-password"
            [attr.aria-invalid]="loginForm.controls.password.invalid && loginForm.controls.password.touched"
          />
          <button
            type="button"
            class="cart-auth-modal__toggle-password"
            [class.cart-auth-modal__toggle-password--visible]="!hidePassword"
            aria-label="Mostrar u ocultar contraseña"
            (click)="togglePassword()"
          ></button>
        </div>
      </div>

      <div class="cart-auth-modal__actions">
        <button
          type="submit"
          class="btn cart-auth-modal__btn cart-auth-modal__btn--login"
          [disabled]="loading"
        >
          {{ loading ? 'Iniciando sesión...' : 'Iniciar sesión' }}
        </button>
      </div>
    </form>
  </div>
</div>
